export const suggestionRequest = [
  { label: "Cấp mới", value: "provide" },
  { label: "Gia hạn", value: "evict" },
  { label: "Cấp lại", value: "renew" },
];

export const suggestionVehicleTravelLongTermRequest = [
  { label: "Cấp giấy phép", value: "provide" },
  { label: "Gia hạn giấy phép", value: "evict" },
  { label: "Cấp lại giấy phép", value: "renew" },
];

export const suggestionTicketRequest = [
  { label: "Cấp thẻ", value: "provide" },
  { label: "Cấp lại thẻ", value: "renew" },
];

export const suggestionVehicleTravelRequest = [
  { label: "Cấp giấy phép", value: "provide" },
  { label: "Cấp lại giấy phép", value: "renew" },
];

export const stageRequest = [
  { label: "Ngắn hạn", value: "shortTerm" },
  { label: "Dài hạn", value: "longTerm" },
];

export const ticketTypeRequest = [
  { label: "Cấp vé và giấy đi đường", value: "full" },
  { label: "Chỉ cấp vé", value: "ticket" },
  { label: "Chỉ cấp giấy đi đường", value: "passport" },
  { label: "Hoàn vé", value: "refund" }
];

export const eApprovedOptions = (window.location.href.includes("localhost") || window.location.href.includes("dev")) ? [
  { label: "Huỳnh Thông", value: "canbo1@viags.vn", default: true },
  { label: "Nguyễn Văn Thanh", value: "canbo2@viags.vn", default: true },
  { label: "Nguyễn Tấn Tài", value: "culi1@viags.vn", default: true },
  { label: "Botit", value: "botit@viags.vn", default: true },
  { label: "HC eOffice", value: "namphuonghc@viags.vn", default: true },
] : [
  { label: "Đỗ Thị Thanh Hương", value: "huongdtt@viags.vn", default: true },
  { label: "Trần Thị Tú Anh", value: "anhttt@viags.vn", default: true },
  { label: "Châu Thị Hồng Nhung", value: "nhungcth@viags.vn", default: true },
  { label: "Bùi Thị Quỳnh Như", value: "nhubtq@viags.vn", default: true },
  { label: "Bùi Thị Sương", value: "suongbt@viags.vn", default: true },
  { label: "Phạm Thị Thu Hương", value: "huongptt@viags.vn", default: true },
]

export const eApprovalChangeOptions = (window.location.href.includes("localhost") || window.location.href.includes("dev")) ? [
  { label: "Huỳnh Thông", value: "canbo1@viags.vn", default: true },
  { label: "Nguyễn Văn Thanh", value: "canbo2@viags.vn", default: true },
  { label: "Nguyễn Tấn Tài", value: "culi1@viags.vn", default: true },
  { label: "Botit", value: "botit@viags.vn", default: true },
] : [
  { label: "Phạm Đức Hồng", value: "hongpd@viags.vn", default: true },
  { label: "Phạm Tuyết Hà", value: "hapt@viags.vn", default: true },
  { label: "Trần Thị Hồng Vân", value: "vantth@viags.vn", default: true },
  { label: "Nguyễn Văn Nam", value: "namnv@viags.vn", default: true },
  { label: "Lê Quang Đức", value: "duclq@viags.vn", default: true },
]

export const eTicketOptions = (window.location.href.includes("localhost") || window.location.href.includes("dev")) ? [
  { label: "Huỳnh Thông", value: "canbo1@viags.vn", default: true },
  { label: "Nguyễn Văn Thanh", value: "canbo2@viags.vn", default: true },
  { label: "Nguyễn Tấn Tài", value: "culi1@viags.vn", default: true },
  { label: "Botit", value: "botit@viags.vn", default: true },
] : [
  { label: "Phạm Thị Thu Hương", value: "huongptt@viags.vn", default: true },
  { label: "Trần Thị Tú Anh", value: "anhttt@viags.vn", default: true },
  { label: "Đỗ Thị Thanh Hương", value: "huongdtt@viags.vn", default: true },
  { label: "Lê Ngọc Thanh Trà", value: "tralnt@viags.vn", default: true },
]

export const eApprovedESCCOptions = (window.location.href.includes("localhost") || window.location.href.includes("dev")) ? [
  { label: "Huỳnh Thông", value: "canbo1@viags.vn", default: true },
  { label: "Nguyễn Văn Thanh", value: "canbo2@viags.vn", default: true },
  { label: "Nguyễn Tấn Tài", value: "culi1@viags.vn", default: true },
  { label: "Botit", value: "botit@viags.vn", default: true },
] : [
  { label: "Châu Thị Hồng Nhung", value: "nhungcth@viags.vn", default: true },
  { label: "Bùi Thị Quỳnh Như", value: "nhubtq@viags.vn", default: true },
  { label: "Bùi Thị Sương", value: "suongbt@viags.vn", default: true },
  { label: "Phạm Thị Thu Hương", value: "huongptt@viags.vn", default: true },

]

export const eApprovedVTCOptions = (window.location.href.includes("localhost") || window.location.href.includes("dev")) ? [
  { label: "Huỳnh Thông", value: "canbo1@viags.vn", default: true },
  { label: "Nguyễn Văn Thanh", value: "canbo2@viags.vn", default: true },
  { label: "Nguyễn Tấn Tài", value: "culi1@viags.vn", default: true },
  { label: "Botit", value: "botit@viags.vn", default: true },
] : [
  { label: "Châu Thị Hồng Nhung", value: "nhungcth@viags.vn", default: true },
  { label: "Bùi Thị Quỳnh Như", value: "nhubtq@viags.vn", default: true },
  { label: "Châu Thị Hồng Nhung", value: "nhungcth@viags.vn", default: true },
  { label: "Phạm Thị Thu Hương", value: "huongptt@viags.vn", default: true },
]

export const eApprovedEVTCOptions = (window.location.href.includes("localhost") || window.location.href.includes("dev")) ? [
  { label: "Huỳnh Thông", value: "canbo1@viags.vn", default: true },
  { label: "Nguyễn Văn Thanh", value: "canbo2@viags.vn", default: true },
  { label: "Nguyễn Tấn Tài", value: "culi1@viags.vn", default: true },
  { label: "Botit", value: "botit@viags.vn", default: true },
] : [
  { label: "Châu Thị Hồng Nhung", value: "nhungcth@viags.vn", default: true },
  { label: "Bùi Thị Quỳnh Như", value: "nhubtq@viags.vn", default: true },
  { label: "Bùi Thị Sương", value: "suongbt@viags.vn", default: true },
  { label: "Phạm Thị Thu Hương", value: "huongptt@viags.vn", default: true },

]


